<template>
    <div class="live-column">

        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <img :src="live.cover_img" class="live-column-banner">

        <div class="live-column-header">
            <div class="header-title">{{live.title}}</div>
            <div class="header-author"><span>{{live.content}}</span>  已开展{{live.current_count}}节 | 共{{live.total_count}}节</div>
        </div>

        <div class="live-share-box">
            <img @click="openShareData" src="/static/bytx/detail_share_btn.svg" alt="">
            <img @click="$toHomePage" src="/static/bytx/detail_back_home_btn.svg" alt="">
        </div>

        <div class="live-column-content">

            <div style="margin-top: 20px" v-if="forecast != null && forecast.length > 0">
                <div class="live-list-section-title">直播中/预告</div>
                <div class="live-list-section">
                    <van-row @click="go_detail(item)" v-for="item in forecast" :key="item.id">
                        <div class="live-list-section-box">
                            <div class="live-list-section-left">
                                <van-image
                                    class="live-list-section-left-img"
                                    fit="contain"
                                    :src="item.cover_img"
                                />
                                <div v-if="item.live_status==0" class="live-list-section-left-zl">直播预告</div>
                                <div v-else-if="item.live_status==1" class="live-list-section-left-zl current">
                                    <img src="/static/bytx/activity_list_live_icon.gif" alt=""> 直播中
                                </div>
                            </div>
                            <div class="live-list-section-right">
                                <div class="live-list-section-right-title">{{item.title}}</div>
                                <div class="live-list-section-right-detail">{{item.start_at}}
                                    <span class="live-list-section-right-detail-join">
                                  {{item.live_status === 0 ? item.isAppointment ? '已预约':'预约' : '加入'}}
                              </span>
                                </div>
                            </div>
                        </div>
                    </van-row>
                </div>
            </div>

            <div style="margin-top: 20px" v-if="backs && backs.length > 0">
                <div class="live-list-section-title">精彩回放</div>
                <div class="live-list-section" style="margin-top: 22px">
                    <van-row @click="go_detail(item)" v-for="item in backs" :key="item.id">
                        <div class="live-list-section-box">
                            <div class="live-list-section-left">
                                <van-image
                                    class="live-list-section-left-img"
                                    fit="contain"
                                    :src="item.cover_img_s==''?item.cover_img:item.cover_img_s"
                                />
                                <div class="live-list-section-left-zl">直播回放</div>
                                <div class="live-list-section-left-time"><span>{{item.duration_format}}</span></div>
                            </div>
                            <div class="live-list-section-right">
                                <div class="live-list-section-right-title">{{item.title}}</div>
                                <div class="live-list-section-right-detail">{{item.view_count}}人观看</div>
                            </div>
                        </div>
                    </van-row>
                </div>
            </div>
        </div>

        <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
            <img class="share-top-img" src="/static/img/pic_course_share_text.svg" alt="">
            <div class="share-img">
                <img :src="htmlUrl" style="width: 100%" v-if="htmlUrl != ''" alt="">
            </div>
            <div class="share-cancel-btn" @click="showShareDialog = false">
                <img src="/static/img/course/icon_course_share_close.svg" alt="">
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import Interface from "@/util/interface"
    import columnSkeleton from "@/skeleton/columnSkeleton"
    export default {
        name: 'live-column',
        components :{
            'column-skeleton' : columnSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                list: [],
                loading: true,
                finished: false,
                live:{},
                forecast:[],
                backs:[],
                share_data :{},
                showShareDialog:false,
                htmlUrl:"",
                isShow:false,
                status:"",
            }
        },
        methods : {
            onLoad() {
                // 数据全部加载完成
                if (this.list.length >= 40) {
                    this.finished = true;
                }
            },
            fetch(scene){
                if (scene === 'live') {
                    Interface.getData('get', Interface.live.column.detail+this.id).then((res) => {
                        this.live = res.data.live
                        this.forecast  = res.data.forecast
                        this.backs  = res.data.backs
                        this.loading = false;
                        if(this.live){
                            Interface.getShareInfo(this,this.live.title,this.live.cover_img,"")
                        }
                    })
                }else if (scene === 'share') {
                    let params = {
                        content_id : this.id,
                        type:4,
                    }
                    Interface.getData('get', Interface.share,params).then((res) => {
                        this.htmlUrl = res.data.post_img_url
                    })
                }
            },
            favorite(){
                Interface.getData('get', Interface.live.favorite+'/'+this.id).then((res) => {
                    if(res.code == 0){
                        this.live.isFavorite = !this.live.isFavorite
                    }
                })
            },
            onClickIcon(){

            },
            onClickButton(){

            },
            go_detail(item){
                if(item.live_status === 6){
                    this.$router.push({'name':'live-detail-home',params:{id:item.id}})
                }else{
                    this.$router.push({'name':'live-detail',params:{id:item.id}, query: { pageType: 2 }})
                }
            },
            openShareData(){
                this.showShareDialog = true
            }
        },
        created(){
            this.id = this.$route.params.id
            this.fetch('live')
            this.fetch('share')
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/live/column/index.vue